// src/components/Layout.js
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";

export default function Layout() {
  const location = useLocation();
  const hideNavbar = location.pathname === "/login";

  return (
    <>
      {!hideNavbar && <Navbar />}
      <main style={{ padding: "1rem" }}>
        <Outlet />  {/* This is where child routes render */}
      </main>
    </>
  );
}